import ActionCable from 'actioncable'

const ActionCableJwt = {
  createConnection: (jwtCallback) => {
    ActionCable.getConfig = () => null
    ActionCable.createWebSocketURL = url => url.replace(/^http/, 'ws')

    ActionCable.Connection.prototype.open = async function open() {
      if (this.isActive()) {
        ActionCable.log(`Attempted to open WebSocket, but existing socket is ${(this.getState())}`)
        return false
      }

      jwtCallback().then((jwt) => {
        if (jwt) {
          ActionCable.log(`Opening WebSocket, current state is + ${(this.getState())}, subprotocols: ${ActionCable.INTERNAL.protocols.concat(jwt)}`)
          if (this.webSocket != null) this.uninstallEventHandlers()
          this.webSocket = new ActionCable.WebSocket(
            `${this.consumer.url}?token=${jwt}`, ActionCable.INTERNAL.protocols.concat(jwt),
          )
          // this.webSocket.protocol = 'actioncable-v1-json'
          this.installEventHandlers()
          this.monitor.start()
        }
      })
      return true
    }

    return ActionCable
  },
}

export default ActionCableJwt



// WEBPACK FOOTER //
// ./src/utils/api/ActionCableJwt.js